import { useEffect, useState } from "react";
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Input,
    InputGroup,
    InputGroupText,
    Row,
    Spinner
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import GroupService from "../Services/GroupService";
import { GroupDto } from "../types/Group";
import GroupTable from "./GroupTable";
import AppSettingsPage from "../Pages/AppSettingsPage";

const AdminGroupListPage = () => {

    const navigate = useNavigate();

    const [groups, setGroups] = useState<GroupDto[]>([]);
    const [loading, setLoading] = useState(true);
    const [allGroups, setAllGroups] = useState<GroupDto[]>([]);
    const [keyword, setKeyword] = useState("");

    useEffect(() => {
        loadGroups();
    }, []);

    const loadGroups = async () => {
        try {
            const result = await GroupService.getAll();

            setAllGroups(result);
            setGroups(result);
        } finally {
            setLoading(false);
        }
    };

    const filterGroups = (value: string) => {
        setKeyword(value);

        if (!value.trim()) {
            setGroups(allGroups);
            return;
        }

        const search = value.toLowerCase();

        const filtered = allGroups.filter(group =>
            group.groupName?.toLowerCase().includes(search) ||
            group.category?.toLowerCase().includes(search) ||
            group.type?.toLowerCase().includes(search) ||
            group.region?.toLowerCase().includes(search) ||
            group.state?.toLowerCase().includes(search) ||
            group.district?.toLowerCase().includes(search)
        );

        setGroups(filtered);
    };



    return (

        <Container fluid>

            <Card>

                <CardBody>

                    <Row className="align-items-center mb-3">

    {/* Search */}
    <Col xs="12" md="2" lg="2">
        <InputGroup
            style={{
                maxWidth: "350px", marginTop:"12px",
            }}
        >
            <InputGroupText
                style={{
                    background: "#2563eb",
                    color: "#fff",
                    border: "none",
                }}
            >
                🔍
            </InputGroupText>

            <Input
                className="Search-input"
                placeholder="Search Group..."
                value={keyword}
                onChange={(e) => filterGroups(e.target.value)}
            />
        </InputGroup>
    </Col>

    {/* Settings */}
    <Col xs="12" md="4" lg="4" className="mt-2 mt-md-0">
        <AppSettingsPage />
    </Col>

    {/* Buttons */}
    <Col
        xs="12"
        md="5"
        lg="5"
        className="d-flex justify-content-md-end justify-content-start gap-2 mt-3 mt-md-0 flex-wrap"
    >
        <Button
            color="primary"
            onClick={() => navigate("/admin/groups/import")}
        >
            Import Groups
        </Button>

        <Button
            color="success"
            onClick={() => navigate("/admin/groups/create")}
        >
            + Create Group
        </Button>
    </Col>

</Row>

                    {
                        loading
                            ?
                            <Spinner />
                            :
                            <GroupTable
                                groups={groups}
                                refresh={loadGroups}
                            />
                    }

                </CardBody>

            </Card>

        </Container>

    );



};

export default AdminGroupListPage;